import React from 'react';
import { Navigate } from 'react-router-dom';

class CommunityInvitePage extends React.Component {
  render() {
    return <Navigate to="/" />
  }
}

export default CommunityInvitePage;